<app-consultation-request-header></app-consultation-request-header>
<section class="payment-section section">
  <div class="container">
    <app-payment-card-form
      #paymentCardFormComponent
      class="is-block mt-4"
      [enablePayLater]="false"
      [lineItems]="lineItems"
      [previousBalanceInCents]="previousBalanceInCents"
      (paymentsSelected)="onPaymentsSelected($event)"
    ></app-payment-card-form>
    @if (processing) {
      <div class="mt-4">
        <app-processing-warning-notification>
          Please do not refresh, close, or navigate away from this page.
        </app-processing-warning-notification>
      </div>
    }
    <app-payment-submit-button
      #submitButton
      class="is-block mt-4 mb-5"
      [processing]="processing"
      [payments]="payments"
      [(submissionErrors)]="submissionErrors"
      (paymentSubmitted)="submit()"
    ></app-payment-submit-button>
  </div>
</section>
